import React from 'react';

import Aboutawardscelebrations from './Aboutawardscelebrations'
import AboutAwardsbanner from './AboutAwardsbanner';
import Aboutusawardsection from './Aboutusawardsection';
import SocialResponsibilitesBanner from './SocialResponsibilitesBanner';
import Socialresponsesectioncontetn from './Socialresponsesectioncontetn';
import SocailresponsibilitesAdvviser from './SocailresponsibilitesAdvviser';
import NewsandeventsBanner from './NewsandeventsBanner';
import Newsandeventscards from './Newsandeventscards';
import PoadcostBanner from './PoadcostBanner';
import Poadcostvideossections from './Poadcostvideossections'
const Poadcost = () => {
    return (
        <div style={{ backgroundColor: '#fff' }}>
            {/* <NewsandeventsBanner /> */}
            <PoadcostBanner />
            <Poadcostvideossections />
            {/* <Newsandeventscards /> */}
            {/* <SocialResponsibilitesBanner /> */}
            {/* <Socialresponsesectioncontetn /> */}
            {/* <SocailresponsibilitesAdvviser /> */}
          
        </div>
    );
};

export default Poadcost;
